// extracted by mini-css-extract-plugin
export default {"app":"main_app__xCeCB","baseUI":"main_baseUI__62aMb","mainPanelWrapper":"main_mainPanelWrapper__LuSxT","mainPanel":"main_mainPanel__XC0UV"};